<template>
  <section>
    <v-col>
      <!-- Back button -->
      <v-row class="ma-0 mb-4">
        <v-btn color="secondary" class="text-capitalize" @click="onBack">{{
          $translate('BACK')
        }}</v-btn>
      </v-row>

      <h2 class="mb-5">{{ $translate('SUBSCRIPTION_INTRODUCTION_TITLE') }}</h2>
      <div
        class="text-subtitle-1 mb-5"
        v-html="$translate('SUBSCRIPTION_INTRODUCTION_DESC')"
      ></div>
      <span v-if="benefits.length > 0">
        {{ $translate('BENEFITS_GLANCE') }}</span
      >

      <!-- Subscription benefits -->
      <ProductBenefits
        v-if="benefits.length > 0"
        :title="benefitsTitle"
        :benefits="benefits"
        class="mb-8"
      ></ProductBenefits>

      <!-- Next button -->
      <v-row class="ma-0 mt-4" justify="end">
        <v-btn
          color="primary"
          class="text-capitalize primary-font-color"
          @click="onNext"
          >{{ $translate('CONTINUE') }}</v-btn
        >
      </v-row>
    </v-col>

    <!-- Dialog to show login info -->
    <ConfirmDialog
      :visible="showLoginAlertDialog"
      :title="$translate('LOGIN_REQUIRED')"
      :message="$translate('SUBSCRIPTION_LOGIN_ALERT')"
      :negativeBtnText="$translate('CANCEL')"
      :positiveBtnText="$translate('CONTINUE')"
      @negativeBtnClicked="showLoginAlertDialog = false"
      @positiveBtnClicked="showLoginDialog"
    ></ConfirmDialog>

    <!-- Dialog to show buy by account reminder -->
    <ConfirmDialog
      :visible="showBuyByAccountDialog"
      :title="$translate('MESSAGE')"
      :message="$translate('SUBSCRIPTION_BUY_BY_ACCOUNT_REMINDER_MSG')"
      :negativeBtnText="$translate('CANCEL')"
      :positiveBtnText="$translate('CONTINUE')"
      @negativeBtnClicked="showBuyByAccountDialog = false"
      @positiveBtnClicked="goToNextPage"
    ></ConfirmDialog>
  </section>
</template>

<script>
import ProductBenefits from '@/components/event/productDetails/ProductBenefits';
import ConfirmDialog from '@/components/generalComponents/uiComponents/ConfirmDialog';

export default {
  name: 'SubscriptionIntroduction',
  components: {
    ProductBenefits,
    ConfirmDialog,
  },
  data() {
    return {
      benefitsTitle: '',
      showLoginAlertDialog: false,
      nextBtnClicked: false,

      showBuyByAccountDialog: false,
    };
  },
  computed: {
    pgInfo() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    benefits() {
      const benefitsArray = [];

      if (this.pgInfo == null) {
        return benefitsArray;
      }

      for (let suffix = 1; suffix <= 5; ++suffix) {
        const benefitKey = `SubscriptionBenefit${suffix}`;
        if (
          this.pgInfo[benefitKey] != null &&
          this.pgInfo[benefitKey].trim() !== ''
        ) {
          benefitsArray.push(this.pgInfo[benefitKey]);
        }
      }

      return benefitsArray;
    },
    userLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
    buyByAccountPartiallyConfigured() {
      return this.$store.getters['auth/buyByAccountPartiallyConfigured'];
    },
    directDebitActivated() {
      const userObj = this.$store.getters['auth/user'];
      if (userObj != null && userObj.allowDirectDebit) {
        return true;
      }
      return false;
    },
  },
  watch: {
    userLoggedIn() {
      if (this.userLoggedIn && this.nextBtnClicked) {
        // User logged in and wants to continue
        this.onNextForLoggedinUser();
      }
    },
  },
  methods: {
    showLoginDialog() {
      this.showLoginAlertDialog = false;
      window.EventBus.fire('triggerOpenAccountFromMenu', {
        toggle: true,
        component: 'Login',
      });
    },
    onBack() {
      this.$emit('back');
    },
    onNext() {
      // Subscription requires user to login, and either direct debit activated
      // or MaxBuyingOnAccountAmount configured from all partners in the partner group
      this.nextBtnClicked = true;

      if (this.userLoggedIn) {
        this.onNextForLoggedinUser();
      } else {
        this.showLoginAlertDialog = true;
      }
    },
    onNextForLoggedinUser() {
      if (this.buyByAccountPartiallyConfigured && !this.directDebitActivated) {
        this.showBuyByAccountDialog = true;
      } else {
        this.showBuyByAccountDialog = false;
        this.goToNextPage();
      }
    },
    goToNextPage() {
      this.$emit('next');
    },
  },
};
</script>
